import { Injectable } from '@angular/core';
import { IAreaService } from '../../src/typings/IAreaService';
import { ITypedResponse } from '../../src/typings/ITypedResponse';
import { ProxyService } from '../proxy/ProxyService';

// Provides access to the areas of the current location.

@Injectable({
    providedIn: 'root'
})
export class AreaService implements IAreaService {
    public static $name: string = 'areaService';

    constructor(
        private proxyService: ProxyService
    ) {
    }

    public getLocationAreas(locationId: number, requestContext: string, includeHasSensors: boolean):
        angular.IPromise<CASLink.Infrastructure.Ui.ViewModel.Location.TagViewModel[]> {
            return this.proxyService.request({
                endPoint: 'location',
                notificationDelay: -1,
                options: {
                    headers: {
                        'Request-Context': requestContext
                    }
                },
                queryParams: {
                    includeHasSensors: includeHasSensors
                },
                route: 'getLocationAreas',
                routeParams: {
                    locationId: locationId
                },
            }).asArray<CASLink.Infrastructure.Ui.ViewModel.Location.TagViewModel>();
        }

    public getLocationAreasResetCache(locationId: number, requestContext: string, includeHasSensors: boolean):
        angular.IPromise<CASLink.Infrastructure.Ui.ViewModel.Location.TagViewModel[]> {
            return this.proxyService.request({
                endPoint: 'location',
                notificationDelay: -1,
                options: {
                    headers: {
                        'Request-Context': requestContext
                    }
                },
                queryParams: {
                    invalidateCache: true,
                    includeHasSensors: includeHasSensors
                },
                route: 'getLocationAreas',
                routeParams: {
                    locationId: locationId
                },
            }).asArray<CASLink.Infrastructure.Ui.ViewModel.Location.TagViewModel>();
        }

    public getModuleAreas(moduleId: number, requestContext: string):
        angular.IPromise<ITypedResponse<CASLink.Infrastructure.Ui.ViewModel.Location.QrMonitoringAreaViewModel>> {
            return this.proxyService.request({
                endPoint: 'location',
                notificationDelay: -1,
                options: {
                    headers: {
                        'Request-Context': requestContext
                    }
                },
                route: 'getModuleAreas',
                routeParams: {
                    moduleId: moduleId
                }
            }).as<ITypedResponse<CASLink.Infrastructure.Ui.ViewModel.Location.QrMonitoringAreaViewModel>>();
        }
}
